import {ADD_APPOINTMENT, REMOVE_APPOINTMENT} from '../types.js'

const initState = {
  appointments: [
    {id: '1', client_name: 'Sandy Cheeks', date: '2019-07-01 14:30:00', stylist_id: 1, service: [{type: 'femaleHair', quantity: 2},{type: 'kidHairColor', quantity: 1}]},
    {id: '2', client_name: 'Asuka Kazama', date: '2019-07-01 15:30:00', stylist_id: 2, service: [{type: 'femaleHair', quantity: 1}]},
    {id: '3', client_name: 'Spongebob Squarepants', date: '2019-08-01 15:30:00', stylist_id: 2, service: [{type: 'femaleHair', quantity: 1}]},
    {id: '4', client_name: 'Patrick Star', date: '2019-07-05 11:30:00', stylist_id: 1, service: [{type: 'femaleHair', quantity: 1}]},
    {id: '5', client_name: 'Mr. Krabs', date: '2019-07-05 11:20:00', stylist_id: 2, service: [{type: 'femaleHair', quantity: 1}]},
    {id: '6', client_name: 'Bruce Wayne', date: '2019-07-10 15:30:00', stylist_id: 1, service: [{type: 'femaleHair', quantity: 1}]},
    {id: '7', client_name: 'Neo Anderson', date: '2019-07-21 15:30:00', stylist_id: 1, service: [{type: 'femaleHair', quantity: 1}]},
    {id: '8', client_name: 'Clark Kent', date: '2019-08-03 10:30:00', stylist_id: 2, service: [{type: 'femaleHair', quantity: 1}]},
  ],
  businessHours: [
    {id: '1', day: 0, startTime: null, endTime: null, status: 'closed'},
    {id: '2', day: 1, startTime: {'day': 1, 'hour': 8, 'minute': 0, 'second': 0}, endTime: {'day': 1, 'hour': 22, 'minute': 0, 'second': 0}, status: 'open'},
    {id: '3', day: 2, startTime: {'day': 2, 'hour': 8, 'minute': 0, 'second': 0}, endTime: {'day': 1, 'hour': 22, 'minute': 0, 'second': 0}, status: 'open'},
    {id: '4', day: 3, startTime: {'day': 3, 'hour': 8, 'minute': 0, 'second': 0}, endTime: {'day': 1, 'hour': 22, 'minute': 0, 'second': 0}, status: 'open'},
    {id: '5', day: 4, startTime: {'day': 4, 'hour': 8, 'minute': 0, 'second': 0}, endTime: {'day': 1, 'hour': 22, 'minute': 0, 'second': 0}, status: 'open'},
    {id: '6', day: 5, startTime: {'day': 5, 'hour': 8, 'minute': 0, 'second': 0}, endTime: {'day': 1, 'hour': 22, 'minute': 0, 'second': 0}, status: 'open'},
    {id: '7', day: 6, startTime: {'day': 6, 'hour': 8, 'minute': 0, 'second': 0}, endTime: {'day': 1, 'hour': 22, 'minute': 0, 'second': 0}, status: 'open'}
  ]
  // moment().format('LT') // 08:30 PM
}

const appointmentReducer = (state = initState, action) => {
  switch(action.type) {
    case ADD_APPOINTMENT:
      return {
        ...state,
        appointments: [...state.appointments, action.payload]
      }
    case REMOVE_APPOINTMENT:
      return {
        ...state,
        appointments: action.payload
      }
    default:
      return state;
  }
}

export default appointmentReducer
